module.exports = __webpack_public_path__ + "img/knowlagebase-app.675e88dd.jpg";